<template>
  <PopupXSmall @close="close">
    <div class="con">
      <div class="tit">{{ t('change_summary_title') }}</div>
      <div class="txtarea-box">
        <textarea :value="title" @input="handleTitle" />
        <span>{{ title.length }} / 30</span>
      </div>
      <div class="btn-wrap">
        <button type="button" class="gray-btn m-btn" @click="close">
          <span>{{ t('label_cancel') }}</span>
        </button>
        <button type="button" class="primary-btn m-btn" @click="confirm">
          <span>{{ t('button_save') }}</span>
        </button>
      </div>
    </div>
  </PopupXSmall>
</template>
<script setup lang="ts">
import { onMounted } from 'vue';

import PopupXSmall from '@/components/shared/composite/PopupXSmall.vue';
import { useToastStore } from '@/stores/toast';
import { ChatScript } from '@/types/response';

const props = withDefaults(
  defineProps<{
    script: ChatScript;
  }>(),
  {
    script: () => ({}) as ChatScript,
  }
);

const emit = defineEmits<{ close: []; confirm: [chatId: string, title: string] }>();

const toastStore = useToastStore();

const { t } = useI18n();

const isOpen = ref<boolean>(false);
const title = ref<string>('');

const errorMessage = computed<string>(() => {
  if (!title.value.length) {
    return t('error_min_length_1');
  }

  if (title.value.length > 30) {
    return t('error_max_length_30');
  }

  return '';
});

const handleTitle = (e) => {
  title.value = e.target.value;
};

const close = () => {
  isOpen.value = false;

  setTimeout(() => {
    emit('close');
  }, 300);
};

const confirm = () => {
  if (errorMessage.value) {
    toastStore.error(errorMessage.value);
    return;
  }

  emit('confirm', props.script.chatId, title.value);
  close();
};

onMounted(() => {
  title.value = props.script.title;

  setTimeout(() => {
    isOpen.value = true;
  }, 10);
});
</script>
<style scoped lang="scss">
.con {
  .tit {
    font-size: $font-size-psmall;
    padding-bottom: 0.5rem;
    color: var(--font-default);
  }
  .txtarea-box {
    span {
      font-size: $font-size-xs;
      color: $color-gray-200;
      padding: 0.25rem 0;
      display: block;
      text-align: right;
    }
  }
  .btn-wrap {
    width: 100%;
    display: flex;
    gap: $size-s;
    margin-top: $size-l;
    button {
      width: calc(50% - 4px);
    }
  }
}
</style>
